export default __webpack_public_path__ + "static/media/jual_sewa_alat_musik.621ed8a3.svg";